export default "__VITE_ASSET__CgT_ZstV__"